export class DtoHistoryRequest {

    public constructor(public id: number, public page: number, public size: number) {
    }

    public static createDefaultRequest(id: number): DtoHistoryRequest {
        return new DtoHistoryRequest(id, 0, 20);
    }

    public static create(id: number, page: number, size: number): DtoHistoryRequest {
        return new DtoHistoryRequest(id, page, size);
    }

}